import type { ReactNode } from 'react'

/**
 * The keywords marked in `text`, case-insensitively — plain text and <mark>, never HTML.
 *
 * The search's two readers of a match's text share it: the global search's Messages
 * rows (sidebar/MessageResults) and the conversation search's panel for a match older
 * than the view can load (agents/search/SearchStrip). The text is someone's message,
 * so it is only ever a string child — the words `<b>` in it stay the words `<b>`.
 */
export function markKeywords(text: string, keywords: readonly string[]): ReactNode[] {
  const words = keywords.map((k) => k.trim()).filter(Boolean)
  if (!words.length) return [text]
  const lower = text.toLowerCase()
  const out: ReactNode[] = []
  let at = 0
  while (at < text.length) {
    let best = -1
    let len = 0
    for (const w of words) {
      const i = lower.indexOf(w.toLowerCase(), at)
      if (i >= 0 && (best < 0 || i < best || (i === best && w.length > len))) {
        best = i
        len = w.length
      }
    }
    if (best < 0) break
    if (best > at) out.push(text.slice(at, best))
    out.push(<mark key={best}>{text.slice(best, best + len)}</mark>)
    at = best + len
  }
  if (at < text.length) out.push(text.slice(at))
  return out
}
